interface VideoSectionProps {
  isDarkMode: boolean;
}

export default function VideoSection({ isDarkMode }: VideoSectionProps) {
  return (
    <section id="video" className={`py-20 px-4 ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <div className="max-w-5xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className={`inline-block text-sm font-semibold tracking-widest uppercase mb-3 ${isDarkMode ? 'text-emerald-400' : 'text-emerald-600'}`}>
            精彩回顧
          </span>
          <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            觀看賽事影片
          </h2>
          <p className={`text-lg max-w-2xl mx-auto ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
            欣賞大灣區乒乓球賽事精彩片段，感受乒乓球運動的魅力
          </p>
        </div>

        {/* Video Embed */}
        <div className={`rounded-2xl overflow-hidden ${isDarkMode ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
          <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
            <iframe
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/CKQiNryiYQ0?autoplay=1&mute=1&start=282"
              title="大灣區乒乓球賽事影片"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <a
            href="https://www.youtube.com/@greaterbayttaasso"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 px-8 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-full transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-youtube-fill text-xl"></i>
            訂閱我們的 YouTube 頻道
          </a>
        </div>
      </div>
    </section>
  );
}
